import { render } from "./OrderHistory.vue?vue&type=template&id=06c11af0&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-06c11af0"

export default script